<div #viewport class="editor-viewport" (wheel)="onWheel($event)">
  <canvas #canvas
          [width]="cols * cell"
          [height]="rows * cell"
          class="led-canvas"
          [style.transform]="transform"
          (pointerdown)="onPointerDown($event)"
          (pointermove)="onPointerMove($event)"
          (pointerup)="onPointerUp($event)"
          (pointercancel)="onPointerUp($event)">
  </canvas>

  <span class="zoom-hint" *ngIf="!hideZoomHint" (click)="noteZoomUsed()">
    Pinch to zoom in on the small squares
  </span>
</div>
